import React from 'react';
import styled from '@emotion/styled';

const Title = styled('div')`
	font-size: 20px;
	font-weight: bold;
	padding-bottom: 10px;
	margin-bottom: 20px;

	${props => props.theme.title || ''}
`;

export default function StyledTitle(props) {
	return <Title>{props.children}</Title>;
}
